<script setup lang="ts">
/**
 * This link has expired (Figma `66:47136`).
 *
 * One screen for three causes — expired, already used, malformed. The designer
 * folded them together on purpose: distinguishing them would confirm which
 * tokens once existed (`66:47519`).
 *
 * The illustration is the broken-link render from the mock (`66:47144`), which
 * answers the annotation asking for something that reads as "expired".
 */
import { FairButton } from '@/ui/primitives/FairButton'
import { useI18n } from 'vue-i18n'
import { useAuthModal } from '@/features/auth/store'
import AuthScreenShell from '@/features/auth/ui/parts/AuthScreenShell.vue'
import illustrationUrl from '@/assets/img/auth/illustration-link-expired.png'

const { t } = useI18n()
const authModal = useAuthModal()
</script>

<template>
  <AuthScreenShell
    centered
    :title="t('auth.link_expired.title')"
    :description="t('auth.link_expired.description')"
  >
    <template #art>
      <img
        class="fair-auth-screen__art"
        :src="illustrationUrl"
        alt=""
      >
    </template>

    <FairButton
      class="fair-auth-cta"
      size="medium"
      :label="t('auth.link_expired.request_new_link')"
      @click="authModal.showAuthModal('forgotPassword')"
    />

    <p class="fair-auth-switch">
      <button
        type="button"
        class="fair-auth-form__link"
        @click="authModal.showAuthModal('login')"
      >
        {{ t('auth.link_expired.back_to_login') }}
      </button>
    </p>
  </AuthScreenShell>
</template>
